const APP = {
    onReady() {
        var index = COOKIE.get({name: 'app_index'});
        index = index === '' ? 0 : index;
        APP.status(index); // 5 steps, index starts at 0
        APP.showNextButtonIfValidAll();
        window.addEventListener('resize', () => {
            APP.status(index);
        });
    },
    status(progress) {
        let statusbar = document.getElementById('js-app-statusbar');
        if (statusbar === null) return;
        let stepsContainer = document.getElementById('js-app-steps-container');
        if (stepsContainer === null) return;
        let clientWidth    = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        let containerWidth = stepsContainer.clientWidth;
        fromLeftPx  = (((clientWidth - containerWidth) / 2) + (containerWidth / 5 * progress) ) + 13;
        fromLeftPc  = 100 / clientWidth * fromLeftPx;
        fromRightPc = progress < 5 ? 100 - fromLeftPc : 0; // last step (=5) goes to the right edge
        statusbar.style.right = fromRightPc + '%';
        let steps = document.querySelectorAll('[data-step]');
        steps.forEach(step => {
            step.classList.remove('active');
            step.classList.remove('finished');
            if (parseInt(step.dataset.step) < progress) {
                step.classList.add('finished');
            } else if (parseInt(step.dataset.step) === progress) {
                step.classList.add('active');
            } else {
                // Add nothing
            }
        });
    },
    addTemplate(that, id) {
        let template = document.getElementById(id);
        if (template === null) return;
        let newNode = template.content.cloneNode(true);
        that.parentNode.insertBefore(newNode, that);
    },
    goTo(that, index) {
        if (that.classList.contains('is-disabled')) return;
        let steps = document.querySelectorAll('[data-index]');
        steps.forEach(step => {
            step.classList.add('is-hidden');
        });
        let currentStep = document.querySelector('[data-index="' + index + '"]');
        currentStep.classList.remove('is-hidden');
        currentStep.animate(
            [
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ],
            {
              duration: 500,
              iterations: 1
            }
        );
        if (CSS.supports('scroll-behavior', 'smooth')) {
            window.scrollTo({ 
                top: 0, 
                behavior: 'smooth' 
            });
        } else {
            // macOS Safari workaround using 'smoothscroll-polyfill'
            window.scroll({ 
                top: 0, 
                left: 0, 
                behavior: 'smooth' 
            });       
        }
        APP.status(index);
        APP.saveInputs(that);
        XHR.load({
            nodeIds: ['xhr-app-overview'],
            functionCall: [APP.showNextButtonIfValidAll]
        });
        COOKIE.set({
            name:  'app_index',
            value: index,
            days:  365
        });
    },
    showNextButtonIfValidAll() {
        let buttons = document.querySelectorAll('.js-watch-button');
        buttons.forEach(button => {
            let index = button.closest('[data-index]');
            if (index === null) return;
            let allInputs = index.querySelectorAll('input[required]');
            var inputs    = [];
            // Remove Inputs which are in hidden containers
            allInputs.forEach(input => {
                var container = input.closest('[data-toggle]') === null ? input.closest('.field') : input.closest('[data-toggle]');
                if (!container.classList.contains('is-hidden')) {
                    inputs.push(input);
                }
            });
            // Focus out logic
            inputs.forEach(input => {
                if (['text', 'number', 'email', 'tel'].includes(input.type)) {
                    input.addEventListener('focusout', () => {
                        var valid = 0;
                        inputs.forEach(node => {
                            (['text', 'number', 'email', 'tel'].includes(node.type) && node.classList.contains('is-success')) && (valid++, FORM.removeError(node));
                        });
                        if (valid === inputs.length) {
                            button.classList.remove('is-disabled');
                        } else {
                            button.classList.add('is-disabled');
                        }
                    });
                }
                if (['checkbox'].includes(input.type)) { // radios are pre-checked
                    input.addEventListener('change', () => {
                        var valid = 0;
                        inputs.forEach(node => {
                            (['checkbox'].includes(node.type) && node.checked) && (valid++, FORM.removeError(node));
                        });
                        if (valid === inputs.length) {
                            button.classList.remove('is-disabled');
                        } else {
                            button.classList.add('is-disabled');
                        }
                    });
                }
            });
            // Button click logic
            button.addEventListener('click', event => {
                if (button.classList.contains('is-disabled')) {
                    var valid = 0;
                    inputs.forEach(input => {
                        (FORM.validateField(input, event)) && (valid++);
                    });
                    if (valid === inputs.length) {
                        button.classList.remove('is-disabled');
                        button.classList.add('is-loading');
                        setTimeout(() => {
                            button.classList.remove('is-loading');
                            button.click();
                        }, 500);
                    } else {
                        button.classList.add('is-disabled');
                    }
                }
            });
            // Button click logic
            let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (clientWidth >= 768) {
                button.addEventListener('mouseover', event => {
                    if (button.classList.contains('is-disabled')) {
                        var valid = 0;
                        inputs.forEach(input => {
                            (FORM.validateField(input, event)) && (valid++);
                        });
                        if (valid === inputs.length) {
                            button.classList.remove('is-disabled');
                            button.classList.add('is-loading');
                            setTimeout(() => {
                                button.classList.remove('is-loading');
                            }, 500);
                        } else {
                            button.classList.add('is-disabled');
                        }
                    }
                });
            }
        });
    },
    saveInputs(that) {
        let form    = that.closest('form');
        let inputs  = form.querySelectorAll('.js-save-input');
        let cookies = {};
        inputs.forEach(input => {
            if ((input.type === 'radio' && input.checked) || (input.type !== 'radio')) {
                // I.e. card_identification[], vehicle_type[]
                let value = input.value !== '' ? encodeURIComponent(APP.escapeHtml(input.value)) : '';
                if (input.name.includes('[]')) {
                    if (!cookies.hasOwnProperty(input.name)) {
                        cookies[input.name] = [];
                    }
                    cookies[input.name].push(value);
                } else {
                    cookies[input.name] = value;
                }
            }
        });
        COOKIE.set({
            name:  'stored_inputs',
            value: JSON.stringify(cookies),
            days:  365
        });
    },
    sendData(that) {
        OVERLAY.loading();
        let form     = that.closest('form');
        let getUrl   = window.location;
        let baseUrl  = getUrl.protocol + '//' + getUrl.hostname + '/';
        let formData = FORM.serialize(form);
        let handler  = 'handler.XHR.php?handler=' + form.dataset.handler;
        let xhr      = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var responseNode = form.querySelector('.form__responses [data-response="' + xhr.response + '"]').content.cloneNode(true);
                } else {
                    var responseNode = form.querySelector('.form__responses [data-response="error"]').content.cloneNode(true);
                }
                FORM.response(form, responseNode);
                document.getElementById('overlay-loading').remove();
            }
        };
        xhr.onerror = (e) => {
            var responseNode = form.querySelector('.form__responses [data-response="error"]').content.cloneNode(true);
            FORM.response(form, responseNode);
            document.getElementById('overlay-loading').remove();
        };
        xhr.send(formData);
        console.log(xhr);
    },
    reIndexCards() {
        let cards = document.querySelectorAll('.js-card');
        var ii = 1;
        cards.forEach(card => {
            var cardIndex = card.querySelector('.js-card-index');
            cardIndex.innerText = ii;
            ii++;
        });
    },
    escapeHtml(string) {
        var entityMap = {
            '<': '&#x3C;',
            '>': '&#x3E;',
            '"': '&#x22;',
            "'": '&#x27;',
            '`': '&#x60;'
        };
        return String(string).replace(/[<>"'`;]/g, (s) => {
            return entityMap[s];
        });
    }
}


